import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store.js";
import login from "./pages/login_page.vue";
import createUser from "./pages/createUser_page.vue";
import resetPasswordRequest from "./pages/resetPasswordRequest_page.vue";
import executePasswordReset from "./pages/executePasswordReset_page.vue";
import createOrganisation from "./pages/createOrganisation_page.vue";
import emailVerified from "./pages/emailVerified_page.vue";
import approveUser from "./pages/approveUser_page.vue";
import workflows from "./pages/workflows_page.vue";
import workflow from "./pages/workflow_page.vue";
import integrations from "./pages/integrations_page.vue";
import templates from "./pages/templates_page.vue";
import admin from "./pages/admin_page.vue";
import unknownRoutePage from "./pages/404_page.vue";
import { Notification } from "element-ui";
import otp from "./pages/otp_page.vue";
import { httpHelper } from "./utils/httpHelper.js";
import Docs_page from "./pages/docs_page.vue";
import Documentation_page from "./pages/documentation_page.vue";

const routes = [
	{
		name: "login",
		path: "/login",
		component: login,
		meta: { requiresAuth: false, page: true, title: "Log In" },
	},
	{
		name: "otp",
		path: "/otp",
		component: otp,
		meta: { requiresAuth: false, page: true, title: "Otp" },
	},
	{
		path: "/signup",
		component: createUser,
		meta: { requiresAuth: false, page: true, title: "Sign Up" },
	},
	{
		path: "/resetPasswordRequest",
		component: resetPasswordRequest,
		meta: { requiresAuth: false, page: true, title: "Reset Password Request" },
	},
	{
		path: "/resetPassword/:token",
		component: executePasswordReset,
		meta: { requiresAuth: false, page: true, title: "Reset Password" },
	},
	{
		path: "/createOrganisation",
		component: createOrganisation,
		meta: { requiresAuth: false, page: true, title: "Create Organisation" },
	},
	{
		path: "/verifyEmail/:userID/:token",
		component: emailVerified,
		meta: { requiresAuth: false, page: true, title: "Email Verification" },
	},
	{
		path: "/approveUser/:organisationName/:token",
		component: approveUser,
		meta: { requiresAuth: false, page: true, title: "Approve User account" },
	},
	{
		name: "workflows",
		path: "/workflows",
		component: workflows,
		meta: { requiresAuth: true, page: true, title: "Workflows" },
	},
	{
		name: "workflow",
		path: "/workflows/:workflowId/:name",
		component: workflow,
		meta: { requiresAuth: true, page: true, title: "Workflow" },
		beforeEnter: async (to, from, next) => {
			await store._actions.returnSpecificWorkflowMETHOD[0]({ workflowId: to.params.workflowId, summary: true });
			const activeWorkflow = store.getters.returnActiveWorkflow;
			if (activeWorkflow) {
				next();
			} else {
				next("/404");
			}
		},
	},
	{
		name: "executions",
		path: "/workflows/:workflowId/:name/executions",
		component: workflow,
		meta: { requiresAuth: true, page: true, title: "Workflow Executions" },
	},
	{
		name: "execution",
		path: "/workflows/:workflowId/:name/executions/:executionId",
		component: workflow,
		meta: { requiresAuth: true, page: true, title: "Execution" },
	},
	{
		name: "integrations",
		path: "/integrations",
		component: integrations,
		meta: { requiresAuth: true, page: true, title: "Integrations" },
	},
	{
		name: "templates",
		path: "/templates",
		component: templates,
		meta: { requiresAuth: true, page: true, title: "Templates" },
	},
		{
		name: "docs",
		path: "/docs",
		component: Docs_page,
		meta: { requiresAuth: true, page: true, title: "Documentation Explorer" },
	},
	{
		name: "documentation",
		path: "/docs/documentation",
		component: Documentation_page,
		meta: { requiresAuth: true, page: true, title: "Documentation" },
	},
	{
		name: "admin",
		path: "/admin",
		component: admin,
		meta: { requiresAuth: true, page: true, title: "Admin" },
		beforeEnter: async (to, from, next) => {
			try {
				const orgName = Vue.$cookies.get("orgName");
				const email = Vue.$cookies.get("email");

				const result = await httpHelper(
					"RUNTIME",
					"GET",
					"security/fetchActiveOrganisations",
					{}
				);

				const organisations = result.response || [];

				const organisation = organisations.find(
					(o) => o.organisationName === orgName
				);

				if (organisation && organisation.organisationAdminEmail === email) {
					next();
					return;
				}

				next("/");
			} catch (e) {
				next("/");
			}
		},
	},
	{
		path: "*",
		component: unknownRoutePage,
		meta: { requiresAuth: false, unknownPath: true, title: "404" },
	},
];

const router = new VueRouter({
	routes: routes,
	mode: "history",
});

router.beforeEach(async (to, from, next) => {
	let loggedIn = store.getters.isLoggedIn || (Vue.$cookies.get("accessToken") ? true : false);
	const authTokenExpiry = new Date(Vue.$cookies.get("accessTokenExpiry"));
	const currentTime = new Date();
	//Define a threshold for "close to" to the expiry of 1 minute
	const threshold = 60 * 1000;
	const authTokenExpiresSoon = currentTime.getTime() >= authTokenExpiry.getTime() - threshold ? true : false;
	if (to.meta.requiresAuth) {
		//Requires authentication
		if (loggedIn && authTokenExpiresSoon) {
			try {
				//Refresh the auth token as it expires soon or has already expired
				await store._actions.refreshTokenMETHOD[0]();
				loggedIn = store.getters.isLoggedIn;
			} catch {
				//Failed to refresh the token so go to login
				Notification({
					title: "Warning",
					message: `You're session has timed out. Please log in.`,
					type: "warning",
					duration: 2000,
				});
				next("/login");
			}
		}
		if (!loggedIn) {
			next("/login");
			Notification({
				title: "Warning",
				message: `Please log in.`,
				type: "warning",
				duration: 2000,
			});
		} else {
			next();
		}
	} else if (to.path === "/" || to.path === "/login" || to.path === "/otp") {
		//Is root login
		if (loggedIn && !authTokenExpiresSoon) {
			next("/workflows");
		} else if (to.path === "/") {
			next("/login");
		} else {
			next();
		}
	} else {
		//Is not root but does not require authentication
		next();
	}
});

const defaultTitle = "Centiloquy";
router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.meta.title || defaultTitle;
	});
});

export default router;
